// SYSTEM_ROUTE: /direction/values
import { DirectionLensView } from './DirectionLensView.js';

export function DirectionValuesScreen() {
  return (
    <DirectionLensView
      lens="values"
      title="Values & Mindsets"
      subtitle="The values and mindsets that guide your choices. Kept honest by linking them to real systems and actions, not slogans."
      placeholder="Name a value or mindset…"
    />
  );
}
